export const api_url = 'https://apiv3.connect24.io';
export const backend_url = 'https://dev.panel.connect24.io/api/';

export const environment = {
  GOOGLE_ID: '',
  VAPID_PUBLIC_KEY:
    'BKY3hQvSOwZP2wa8336fmAiuhpGlQHk9nwdLoyrhsBmIJMm-jEez964i-iYDuIPpC4PTN1W4TOeY5vxDlRcqY3w',
  urlRestList: {
    BACKEND: 'https://dev.panel.connect24.io/api/',
    API: 'https://dev.apiv3.connect24.io',
    APIv2: 'https://apiv2.connect24.io',
    PANEL: 'https://dev.panel.connect24.io/',
    CONTROL: 'https://control.connect24.io',
    DEFAULT: backend_url,
  },
};
